import configuration from '../../../configuration'

export const CartLink = `${configuration.accountSiteUrl}/#/checkout/review`

export const HeaderLinks = [
  {
    href: `${configuration.accountSiteUrl}/#/pricing/`,
    name: 'Pricing',
    active: false,
  },
  {
    href: '/',
    name: 'On-Demand Workouts',
    active: true,
  },
  {
    href: `${configuration.accountSiteUrl}/#/virtual-workouts`,
    name: 'Live Workouts',
    active: false,
  },
  {
    href: `${configuration.accountSiteUrl}/#/games`,
    name: 'CG Games',
    active: false,
  },
  {
    href: `${configuration.accountSiteUrl}/#/store/`,
    name: 'Shop Gear',
    active: false,
  },
]

export default HeaderLinks
